module.exports = __webpack_public_path__ + "static/img/service_introduce_51171_zh_h5.94bef85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_51171_zh_h5.png
// module id = /2JM
// module chunks = 34